import { useState, useContext, useEffect, useMemo } from "react";
import { LanguageContext } from "../../../utils/lang_provider";
import Pagination from "../../../templates/pagination";
import { deleteData, fetchData } from "../../../utils/fetch";
import { useParams, Link } from "react-router-dom";
import { Button, message, Flex } from "antd";
import { PlusOutlined } from '@ant-design/icons'
import ContentTable from "./contentTable";

export default function ContentTablePage() {
  const { type } = useParams();
  const [elements, setElements] = useState([]);
  const { language } = useContext(LanguageContext)
  const [currentPage, setCurrentPage] = useState(0);
  const maxElementsOnPage = 10;
  const [totalPages, setTotalPages] = useState(0);
  
  const options = useMemo(() => ({
    offset: currentPage * maxElementsOnPage,
    limit: maxElementsOnPage,
    type: "BACK"
  }), [currentPage, maxElementsOnPage]);

  async function loadElements() {
      try {
          const data = await fetchData(`admin/${type}`, language, options);
          setElements(data.data || []);
          setTotalPages(Math.ceil((data.length || 0) / maxElementsOnPage));
      } catch (error) {
          console.error('Error loading dashboard:', error);
      }
  }

  useEffect(() => {
    loadElements();
  }, [language, type, options]);

  const [adminTable, setAdminTable] = useState([]);
  useEffect(() => {
    async function loadAdminTable() {
        try {
            const data = await fetchData(`admin/table/${type}`, language);
            setAdminTable(data);
        } catch (error) {
            console.error('Error loading dashboard:', error);
        }
    }
    loadAdminTable();
  }, [language, setAdminTable, type]);

  useEffect(() => {
    setCurrentPage(0)
  }, [type]);

  const transformedColumn = {}

  adminTable.forEach(item => {
    switch (item.action) {
      case 'SUM':
        if (!transformedColumn[item.column_title])
          transformedColumn[item.column_title] = []
        transformedColumn[item.column_title].push(item.column);
        break;
      case 'STATUS':
        transformedColumn[item.column_title] = item.column;
        break;
      default:
        transformedColumn[item.column_title] = item.column
        break;
    }
  })

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo(0, 0);
  };
  
  const deleteEntry = async (type, id) => {
    try {
      const result = await deleteData(`admin/${type}/${id}`, language);
      
      message.success("Successfully deleted entry.")
      await loadElements();
      return result;
    } catch (error) {
      message.error('Failed to delete entry: ' + error.message);
    }
  }

  return (
    <Flex vertical style={{margin: "0 5% 0 5%"}}>
      {type !== "page" && type !== "web-objects" && <Link style={{textAlign:"center", margin: "10px 0 0 0", width: "20px", borderRadius: "10px"}} to={`/admin/content/${type}/create`}>
          <Button>
            <PlusOutlined></PlusOutlined>
          </Button>
      </Link>}
      <ContentTable elements={elements} useType={false} type={type} deleteEntry={deleteEntry}></ContentTable>
      <Pagination totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} />
    </Flex>
  );
}